import { cn } from '@/lib/utils'

interface StatusDotProps {
  status: 'healthy' | 'degraded' | 'down' | 'unknown'
  className?: string
}

const statusColors = {
  healthy: 'bg-success',
  degraded: 'bg-warning',
  down: 'bg-destructive',
  unknown: 'bg-muted-foreground',
}

export function StatusDot({ status, className }: StatusDotProps) {
  return (
    <span className={cn('relative flex h-2.5 w-2.5', className)}>
      {status === 'healthy' && (
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-40" />
      )}
      <span className={cn('relative inline-flex h-2.5 w-2.5 rounded-full', statusColors[status])} />
    </span>
  )
}
